import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QuoteProvider } from './context/QuoteContext';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import QuoteCart from './pages/QuoteCart';
import RequestQuote from './pages/RequestQuote';
import Contact from './pages/Contact';
import Search from './pages/Search';

function App() {
  return (
    <QuoteProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products/:category" element={<ProductList />} />
              <Route path="/product/:productId" element={<ProductDetail />} />
              <Route path="/quote" element={<QuoteCart />} />
              <Route path="/quote-cart" element={<QuoteCart />} />
              <Route path="/request-quote" element={<RequestQuote />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/search" element={<Search />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </div>
      </BrowserRouter>
    </QuoteProvider>
  );
}

export default App;
